import Numeric from './Numeric';

export default Numeric;
